<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="resetItems"
            @cancel="item = false"
            @delete-item="deleteType"
        ></view-item>

        <list-items
            v-else
            title="Transaction Types"
            :items="items"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" @click="item = {}"
                        >Add Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'tables',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins],
    data: () => {
        return {
            componentName:'Transaction Type',
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        items() {
            const items = this.$store.state.transactionType.items
            console.log('items', items)
            return items
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('transactionType/fetchAll')
        },

        showItem(id) {
            this.item = this.items.find(x => x.id === id)
        },

        resetItems(status) {
    
            this.genericToast(this.componentName, status,'success', `${this.componentName} ${status.toLowerCase()} succcessfully`)
            // this.doToast('Success', `Item ${status}!`, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
